import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const PostBodyPlaceHolderContainer = styled.div.withConfig({
  displayName: "ArticlePlaceholder__PostBodyPlaceHolderContainer",
  componentId: "sc-13413kt-0"
})(["width:100%;cursor:pointer;color:", ";"], EERIE);
export default function PostBodyPlaceholder({
  onClick
}) {
  return /*#__PURE__*/_jsx(PostBodyPlaceHolderContainer, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.edit.fields.articleBody.placeholder"
    })
  });
}